import React, { useState, useEffect, useContext } from 'react';
import CreateExpOptions from './CreateExpOptions';
import { RadioGroups } from 'components/customComponents/Layers/InputGroups';
import WizardService from 'business/services/WizardService';
import useRockFetchGet, { useRockFetchPost } from 'utils/RockFetch';
import WizardHeading from 'components/customComponents/Controls/WizardHeading';
import WizardParagraph from 'components/customComponents/Controls/WizardParagraph';
import ScreenWizardContext from './ScreenWizardContext';
import { getWizardDefaultPlateType, isNullOrUndefined } from 'utils/Global';
import DropDownWizardTemplate from 'components/customComponents/Controls/DropDownWizardTemplate';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import { RMModal } from 'components/modal';

function SelectPlateType() {
  const [showDelModal, setShowDelModal] = useState(false);
  const screenWizContext = useContext(ScreenWizardContext);
  const [rockFetchGet] = useRockFetchGet();
  const [rockFetchPost] = useRockFetchPost();
  const [nameValExpTemplates, setnameValExpTemplates] = useState([]);
  const [plateTypes, setPlateTypes] = useState([]);
  const [delTemplateFileName, setDelTemplateFileName] = useState<string>('');
  function changeCreateNewExp() {
    screenWizContext.setCreateNewExp(!screenWizContext.createNewExp);
  }
  useEffect(() => {
    async function fetchPlates() {
      const service: WizardService = new WizardService();
      const response = await service.getPlateTypes();
      response.unshift(getWizardDefaultPlateType());
      if (response != null) {
        setPlateTypes(response);
      }
    }
    fetchPlates();
  }, []);

  useEffect(() => {
    async function fetchTemplates() {
      const response: string[] = await rockFetchGet(
        '/api/ScreenExpWizard/templatenames',
        'get',
        undefined,
        true,
      );
      if (response != null) {
        screenWizContext.setTemplateNames(response);
      }
    }
    fetchTemplates();
  }, []);

  useEffect(() => {
    if (plateTypes.length > 0 && screenWizContext.plateType == null) {
      screenWizContext.setPlateType(plateTypes[0]);
    }
  }, [plateTypes]);
  function cancelTemplateDelete(val) {
    setShowDelModal(val);
  }
  async function postDeleteTemplate() {
    if (delTemplateFileName.length === 0 || isNullOrUndefined(delTemplateFileName)) {
      return;
    }
    const templateNames = screenWizContext.templateNames;
    const delIndex = templateNames.findIndex(
      (tempName) => tempName === delTemplateFileName,
    );

    if (delIndex != -1) {
      templateNames.splice(delIndex, 1);
      screenWizContext.setTemplateNames([...templateNames]);
      if (templateNames.length == 0) {
        screenWizContext.setCreateNewExp(true);
      }
    }
    const response = await rockFetchPost(
      '/api/screenExpWizard/deleteTemplateName',
      delTemplateFileName,
    );
    setShowDelModal(false);
    if (response != null) {
      return response;
    }
  }

  useEffect(() => {
    const templates = [];
    screenWizContext.templateNames.forEach((val) => {
      templates.push({
        name: val,
        id: val,
      });
    });
    setnameValExpTemplates(templates);
  }, [screenWizContext.templateNames]);

  function changeExpTemplate(val) {
    screenWizContext.setExpTemplate(val);
  }

  function onChange(e) {
    const pTypeId = parseInt(e.target.value);
    const activePlate = plateTypes.find((platetype) => platetype.id === pTypeId);
    if (!isNullOrUndefined(activePlate)) {
      screenWizContext.setPlateType(activePlate);
      const proteins = [];
      for (let index = 0; index < activePlate.totalDrops; index++) {
        proteins.push(null);
      }
      screenWizContext.changeProteins([...proteins]);
    }
  }
  function deleteTemplateName(fileName: string) {
    setShowDelModal(true);
    if (!isNullOrUndefined(fileName)) {
      setDelTemplateFileName(fileName);
    }
  }
  return (
    <>
      <RMModal
        id='selectplatetype-modal'
        showModal={showDelModal}
        setShowModal={cancelTemplateDelete}
        okButtonText="Yes, Proceed"
        noButtonText="No, Cancel"
        body="You’re about to remove 1 item. Are you sure you want to continue?"
        onOk={postDeleteTemplate}
        heading="Remove Item(s)"
      />
      <div id="selectplatetype-wrapper" className="flex-y-center flex-column">
        <WizardHeading text="Welcome to Screen Experiment Wizard" />
        <WizardParagraph
          text="This wizard helps you create several screen experiments at once. In the
        steps that follow you will select the plate type, screens you want to
        use and protein. You will also set the imaging schedule, the experiment
        setup and incubation temperatures, and select an experiment owner."
        />
        <CreateExpOptions
          heading="Create Experiment Options"
          selectedOption={screenWizContext.expTemplate}
          setSelectedOption={changeExpTemplate}
          options={nameValExpTemplates}
          disableSelect={screenWizContext.createNewExp}
        >
          <RadioGroups
            label1="Create New Screen Experiment"
            label2="Create Screen Experiment Based on Saved Wizard Setup"
            radioValue={screenWizContext.createNewExp}
            onChange={changeCreateNewExp}
            disabledSecond={screenWizContext.templateNames.length === 0}
          />
          <DropDownWizardTemplate
            onChange={changeExpTemplate}
            disabled={screenWizContext.createNewExp}
            showTemplateNameModal={deleteTemplateName}
          />
        </CreateExpOptions>
        <CreateExpOptions
          heading="Select Plate Type"
          selectedOption={screenWizContext.plateType?.id}
          setSelectedOption={onChange}
          options={plateTypes}
        >
          <RMSelect
            options={plateTypes}
            selectedValue={screenWizContext.plateType?.id}
            onChange={onChange}
            placeholder={'Select Plate Type'}
          />
        </CreateExpOptions>
      </div>
    </>
  );
}

export default SelectPlateType;
